import './App.scss';

import Routes from '@/routes/index';

function App() {
	return (
		<div className="App">
			<Routes />
		</div>
	);
}

export default App;
